import { Container } from "react-bootstrap";
import ExternalLink from "../ExternalLink";

function Ehrenamt() {
  return (
    <Container style={{ padding: "1.5rem" }}>
      <h1>Ehrenamt</h1>
      <br />

      <p>
        Ehrenamtlich unterstütze ich die EinDollarBrille im Team „Biegemaschinen
        und Tools“.
      </p>

      <p>
        Meine Aufgaben umfassen die Konstruktion, Zeichnungserstellung und
        Dokumentation der Biegemaschine sowie der zugehörigen Werkzeuge im
        CAD-System Solid Edge von Siemens.
      </p>

      <p>
        Das Projekt wird durch das Sponsoring der Solid-Edge-Lizenz von
        Var-Industries und Siemens unterstützt.
      </p>

      <p>
        Weitere Informationen:{" "}
        <ExternalLink href="https://www.eindollarbrille.de">
          www.eindollarbrille.de
        </ExternalLink>
      </p>

      <div className="spacer"></div>
    </Container>
  );
}

export default Ehrenamt;
